import { useQuery } from '@tanstack/react-query'
import { api } from '../../lib/api.js'
import { Spinner, Empty, relTime } from '../../components/ui.jsx'

export function Audit() {
  const q = useQuery({ queryKey: ['audit'], queryFn: () => api.audit('?limit=200') })

  return (
    <div className="main" style={{ margin: '0 auto' }}>
      <h1 className="h1">Registro de auditoría</h1>
      <p className="lede">Append-only. Toda acción sensible queda aquí: logins, despliegues y consultas SQL.</p>

      {q.isPending && <Spinner />}
      {q.data?.length === 0 && <Empty title="Vacío">Todavía no hay eventos registrados.</Empty>}

      {q.data?.length > 0 && (
        <div className="card">
          <div className="table-scroll">
            <table className="t">
              <thead>
                <tr><th>Cuándo</th><th>Acción</th><th>Resultado</th><th>Quién</th>
                    <th>Proyecto</th><th>Detalle</th></tr>
              </thead>
              <tbody>
                {q.data.map((e, i) => (
                  <tr key={i}>
                    <td style={{ color: 'var(--fg-2)', whiteSpace: 'nowrap' }}>{relTime(e.at)}</td>
                    <td className="mono">{e.action}</td>
                    <td>
                      <span className={`badge ${e.outcome === 'success' ? 'done' : e.outcome === 'failure' ? 'error' : ''}`}>
                        <span className="dot" />{e.outcome}
                      </span>
                    </td>
                    <td className="ellipsis" style={{ color: 'var(--fg-2)' }}>{e.actor_email ?? '—'}</td>
                    <td className="mono" style={{ color: 'var(--fg-2)' }}>{e.project_slug ?? '—'}</td>
                    <td className="mono ellipsis" style={{ color: 'var(--fg-3)', fontSize: 12 }}>
                      {e.detail?.sql ?? e.detail?.reason ?? e.detail?.commit ?? JSON.stringify(e.detail ?? {}).slice(0, 90)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  )
}
